///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";

import ChevronDown from "../icons/ChevronDown";

function Accordion({ title, children }) {
  const [open, toggleOpen] = useState(true);

  return (
    <div className="card mb-16 pos-relative">
      <div
        className="card__heading--large pos-relative"
        data-testid="accordion-title"
      >
        {title}
        <button
          className="pos-absolute pos-right pr-20 mr-2 no-focus"
          style={{ zIndex: 0 }}
          onClick={() => toggleOpen(!open)}
        >
          <ChevronDown
            height="7"
            width="12"
            rotateDegree={open ? 180 : 0}
            title=""
          />
        </button>
      </div>
      <div className={open ? "" : "hidden"} data-testid="accordion-section">
        <div
          style={{ borderColor: "#E6E7E8" }}
          className="box--border-top p-16"
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default Accordion;
